export enum PaymentRequiredErrorMessage {
  AccessToModule = "You don't have access to this module. Please contact support.",
  OverduePayment = 'Your account has been blocked due to overdue payment. Please contact support or update your payment method.'
}
